import React, { createContext, useContext, useState, useEffect } from 'react';
import { trackMetaEvent } from '../lib/meta';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const saved = localStorage.getItem('paramparik_cart');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('paramparik_cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product, quantity = 1) => {
    trackMetaEvent('AddToCart', {
      currency: 'INR',
      value: (Number(product.price) || 0) * quantity,
      content_type: 'product',
      content_ids: [String(product.id)],
      num_items: quantity
    });
    setCart(prev => {
      const lineId = product.cartItemId || product.id;
      const existing = prev.find(item => (item.cartItemId || item.id) === lineId);
      if (existing) {
        return prev.map(item =>
          (item.cartItemId || item.id) === lineId
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }
      return [...prev, { ...product, cartItemId: lineId, quantity }];
    });
  };

  const removeFromCart = (lineId) => {
    setCart(prev => prev.filter(item => (item.cartItemId || item.id) !== lineId));
  };

  const updateQuantity = (lineId, quantity) => {
    if (quantity < 1) {
      removeFromCart(lineId);
      return;
    }
    setCart(prev =>
      prev.map(item =>
        (item.cartItemId || item.id) === lineId ? { ...item, quantity } : item
      )
    );
  };

  const clearCart = () => {
    setCart([]);
  };

  const cartTotal = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQuantity, clearCart, cartTotal, cartCount }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
};
